import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import findAttributeValue from './findAttributeValue';
import { GetUserAttributesParams } from './types';

const getUserAttributes = ({ user, onSuccess, onFailure }: GetUserAttributesParams) => {
  user.getUserAttributes((err, result) => {
    if (err) {
      onFailure(err.message);
      return;
    }

    onSuccess({
      email: findAttributeValue('email', result as CognitoUserAttribute[]),
      email_verified: findAttributeValue('email_verified', result as CognitoUserAttribute[]) === 'true',
    });
  });
};

export default getUserAttributes;
